<template>
  <div class="liu">
    <!-- 标题 -->
    <mt-header fixed :title="title" class="title2">
      <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
      <mt-button slot="right" @click="onTitleExplainClick">说明</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
      <!-- 信息列表 -->
      <div class="achi-info detail-list">
        <div class="box-item" v-for="(item, index) in myData.list" :key="index">
          <div class="item-img">
            <svg-icon :icon-class="svgPath" class-name="cur-icon"></svg-icon>
          </div>
          <div class="item-content">
            <span>{{ item.detailed }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Indicator, MessageBox } from 'mint-ui';
import { formatDate } from '@/utils/utils.js';
import { RewardDetailed } from '@/api/user.js';
import { CusToast } from '@/utils/CustomToast';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';

export default {
  name: 'AchievementDetail',
  data() {
    return {
      // 标题
      title: '',
      // svg路径
      svgPath: 'member',
      // 数据
      myData: {
        list: [],
        total: -1,
        scrollDisabled: true,
      },
      // 查询
      myParam: {
        date: '',
        pageNum: 1,
        pageSize: 16,
        type: '',
      },
    };
  },
  mounted() {
    this.initTitle();
    this.initParam();
    this.initData();
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 加载标题
    initTitle() {
      const titleStr = this.$route.query.type === 1 ? '已注册' : '已达标';
      this.title = `业绩明细-${titleStr}`;
    },
    // 加载参数
    initParam() {
      this.myParam.date = this.$route.query.date;
      this.myParam.type = this.$route.query.type;
    },
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 加载数据
      this.getMyData();
    },
    // 通过接口获取数据
    getMyData() {
      Indicator.open();
      this.myData.scrollDisabled = true;
      RewardDetailed(this.myParam)
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.myData.total = res.total;
            this.myData.list.push(...res.rows);
            if (this.myData.list.length < this.myData.total) {
              this.myData.scrollDisabled = false;
            }
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          this.myData.list = [];
          this.myData.total = -1;
          this.myData.scrollDisabled = true;
          this.myParam.pageNum = 1;
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      if (this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },
    onTitleExplainClick() {
      MessageBox({
        message: `已消费金额的统计截止日期为<br/>${formatDate(new Date(new Date().setDate(new Date().getDate() - 1)))}`,
        showCancelButton: false,
        confirmButtonText: '知道了',
      });
    },
    // 填充假数据
    fillFalseData() {
      this.myData.total = 100;
      Indicator.open();
      this.myData.scrollDisabled = true;
      setTimeout(() => {
        Indicator.close();
        for (let i = 0; i < this.myParam.pageSize; i++) {
          const obj = {
            detailed: '*晓雅-159****0001-注册20200404(未达标-已消费500.00)',
          };
          this.myData.list.push(obj);
          if (this.myData.list.length < this.myData.total) {
            this.myData.scrollDisabled = false;
          }
        }
      }, 3000);
    },
  },
};
</script>
